import FoulingLogData from "./data";

export default function mapFoulingLogData(json) {
    return new FoulingLogData(
        json.id,
        json.Vessel,
        json.Date,
        json.Location,
        json.Service_provider,
        json.Report,
        json.Entry_type,
        json.Operating_area,
        json.PP,
        json.HC,
        json.HULL_INSP,
        json.DD,
        json.PHCL,
        json.Notes,
        json.Avg_sailing_speed_knots,
        json.Idle_days_port_anchor_avg_monthly_days_since_last_activity,
        json.Cleaning_method,
        json.PR_Slime,
        json.PR_Growth,
        json.PR_Shells_animals_etc,
        json.PR_Damage_to_blades,
        json.Boottop_Slime,
        json.Boottop_Growth,
        json.Boottop_Shells_animals_etc,
        json.Boottop_Damage_to_paint,
        json.VS_Slime,
        json.VS_Growth,
        json.VS_Shells_animals_etc,
        json.VS_Damage_to_paint,
        json.FB_Slime,
        json.FB_Growth,
        json.FB_Shells_animals_etc,
        json.FB_Damage_to_paint,
        json.vesselID,
        json.date_of_calculation
    );
} 